import React from 'react'

import { Box, Checkbox } from '@factorialco/deprecated-design-system'
import { FormikProps } from 'formik'

import TextArea from 'modules/core/components/TextArea'
import i18n from 'modules/core/lib/i18n'

import { SectionTitle } from './_SectionTitle'

// Define a generic interface for the minimum required form values
interface CustomizeSectionFormValues {
  showMemo: boolean
  memo?: string
  showFooter: boolean
  footer?: string
}

interface CustomizeSectionProps<T extends CustomizeSectionFormValues> {
  form: FormikProps<T>
  readOnly?: boolean
  description: string
}

export const CustomizeSection = <T extends CustomizeSectionFormValues>({
  form,
  description,
  readOnly = false,
}: CustomizeSectionProps<T>) => {
  return (
    <Box width="full" gap="s16" flexDirection="column">
      <SectionTitle
        title={i18n.t('finance.sale_invoices.form.customize_title')}
        description={description}
      />

      <Checkbox
        label={i18n.t('finance.sale_invoices.form.memo')}
        onChange={() => form.setValues({ ...form.values, showMemo: !form.values.showMemo })}
        size="small"
        value="small"
        checked={form.values.showMemo}
        disabled={readOnly}
      />
      {form.values.showMemo && (
        <Box width="full">
          <TextArea
            readonly={readOnly}
            onChange={(value) => {
              if (typeof value == 'string') form.setValues({ ...form.values, memo: value })
            }}
            placeholder={i18n.t('finance.sale_invoices.form.text_area_placeholder')}
            value={form.values.memo || ''}
          />
        </Box>
      )}
      <Checkbox
        label={i18n.t('finance.sale_invoices.form.footer')}
        onChange={() => form.setValues({ ...form.values, showFooter: !form.values.showFooter })}
        size="small"
        value="small"
        checked={form.values.showFooter}
        disabled={readOnly}
      />
      {form.values.showFooter && (
        <Box width="full">
          <TextArea
            readonly={readOnly}
            onChange={(value) => {
              if (typeof value == 'string') form.setValues({ ...form.values, footer: value })
            }}
            placeholder={i18n.t('finance.sale_invoices.form.text_area_placeholder')}
            value={form.values.footer || ''}
          />
        </Box>
      )}
    </Box>
  )
}
